<mat-card class="content-card">

  <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>

  <mat-card-header>
    <mat-card-title>
      <h5>Images - {{albumId}}</h5>
    </mat-card-title>
  </mat-card-header>


  <div class="header w-100" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch()" placeholder="Search" [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>


        <div style="display: inline-block; width: 20px;">
        </div>

        <form>
        <input #fileInput type="file" [style.display]="'none'" (change)="uploadFile($event)">
          <mat-icon style="cursor:pointer;" class="button-icon" (click)="fileInput.click()" aria-label="Edit"> upload </mat-icon>
        </form>


      </div>
    </div>
  </div>

  <app-mat-table-generator #table
                           [saveFilters]=false
                           tableName="uploadsTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="false"
                           [customActions]=""
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           [defaultSortField] = "'uploadDate'"
                           [defaultSortDirection]="'desc'"
  >
  </app-mat-table-generator>
</mat-card>
